/**
 *
 * Asynchronously loads the component for TaxpayerReport
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxreturnReport = lazyLoad(
  () => import('app/modules/ManagementReport/TaxreturnReport/index'),
  (module) => module.TaxreturnReport
);
